<template>
    <div class="dashboard" :class="{ 'is-collapsed': collapsed }">
        <button
            class="rail-collapse-toggle"
            type="button"
            @click="toggle"
            :title="collapsed ? 'Panel einblenden' : 'Panel ausblenden'"
        >
            <i class="material-icons">{{ collapsed ? 'chevron_left' : 'chevron_right' }}</i>
        </button>
        <slot v-if="!collapsed" />
    </div>
</template>

<script>
/**
 * A collapsible right rail — used by the ClientPortal (order pages + dashboard) and
 * the staff user dashboard, so both fold away the same way.
 *
 * A component rather than a mixin because the collapse is driven by CSS that depends
 * on the exact DOM shape (`.dashboard.is-collapsed`). Sharing the markup is the
 * point; a mixin would have left it duplicated at every call site.
 *
 * The collapsed width is carried by the component's own class, so it works in a flex
 * parent (staff dashboard) as well as in the `.trip-dashboard` grid (portal), where
 * an extra `:has()` rule additionally shrinks the grid column.
 *
 * The content sits in a v-if'd slot, so a collapsed rail is *removed* rather than
 * hidden — its children never mount and never fetch.
 */
export default {
    props: {
        /**
         * localStorage key for the collapsed state. Per page, so one subpage's
         * default does not leak into another.
         */
        storageKey: {
            type: String,
            required: true,
        },

        /** Start state until the user has toggled this rail themselves. */
        defaultCollapsed: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            collapsed: false,
        };
    },

    created() {
        const stored = localStorage.getItem(this.storageKey);
        this.collapsed = stored === null ? this.defaultCollapsed : stored === '1';
    },

    methods: {
        toggle() {
            this.collapsed = !this.collapsed;
            localStorage.setItem(this.storageKey, this.collapsed ? '1' : '0');
            this.$emit('toggle', this.collapsed);
        },
    },
};
</script>
